// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".bottom-layout{padding-top:80px;padding-bottom:80px;max-width:600px;display:flex;align-items:center;flex-direction:column}@media only screen and (max-width: 991px){.bottom-layout{padding:48px 20px 80px 20px}}.bottom-layout h3{margin-bottom:16px;text-align:center}.bottom-layout p{margin-bottom:48px;text-align:center}.bottom-layout .wrapper-btn button{margin:0 12px 24px 12px;width:236px}.faq-contact .bottom-layout-faqlink{display:none}.home .bottom-layout-nofaqlink{display:none}", ""]);
// Exports
module.exports = exports;
